(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/size-picker.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/size-picker.js');

'use strict';

const {
  productMapping
} = svs.numbergames;
svs.numbergames.game.views.SizePicker = Marionette.View.extend({
  invertButtons: false,
  ui: {
    sizeRadio: '.js-size-radio'
  },
  triggers: {
    'change @ui.sizeRadio': 'changeSize'
  },
  modelEvents: {
    'updated:packages': 'render',
    'change:selectedPackage': 'changedSelectedPackage'
  },
  className() {
    const brandingSuffix = productMapping.getBrandingClass(this.model.get('productId'));
    return "numbergames-size-picker numbergames-size-picker-".concat(brandingSuffix);
  },
  template(data) {
    return svs.numbergames.game.templates.size_picker(data);
  },
  templateContext() {
    const rules = svs.numbergames.game_model.rulesRadio.request('rules');
    const packageRules = rules.PACKAGES;
    if (!packageRules) return;
    const product = this.model.get('productId');
    return {
      possibleSizes: Object.keys(packageRules).map(size => ({
        size: parseInt(size, 10)
      })),
      invertButtons: this.getOption('invertButtons'),
      transparentButton: !productMapping.isEurojackpot(product),
      branding: productMapping.isKeno(product) && productMapping.getBrandingClass(product)
    };
  },
  onChangeSize(view, event) {
    this.model.setPackage(event.target.value);
  },
  changedSelectedPackage() {
    if (!this.model.get('prolongedBet') && !this.model.get('subscriptionId')) {
      var _svs$numbergames$game, _svs$numbergames$game2;
      const size = this.model.get('selectedPackage');
      svs.core.data.title = {
        packageSize: size
      };
      svs.core.data.metaDescription = {
        packageSize: size
      };
      const router = (_svs$numbergames$game = (_svs$numbergames$game2 = svs.numbergames.game_app) === null || _svs$numbergames$game2 === void 0 ? void 0 : _svs$numbergames$game2.router) !== null && _svs$numbergames$game !== void 0 ? _svs$numbergames$game : Backbone.history;
      router.navigate("fardiga-spel/".concat(size), {
        replace: true
      });
    }
  }
});

 })(window);